import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { isMobile } from "../../../../../../src/helpers/Mobile";
import styles from "./TogglePnlTemplateTag.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";
import PrinterModal from "./PrinterModal";
import { DeviceService } from "services/DeviceService";
import { TagService } from "services/TagService";
import useRequest from "hooks/useRequest";
import { EventRepository } from "helpers/EventRepository";
import PrinterIcon from 'assets/images/printer_1042036_1.svg';
import RulerIcon from 'assets/images/pencil-outline-ruler.svg';
import MemoryIcon from 'assets/images/pencil-outline-memory.svg';
import Loader from "../../../../../components/MainApp/atoms/Loader";
import GenericErrorModal from "../../../../../components/MainApp/atoms/Modals/GenericErrorModal";
import DeleteConfigTagsModal from "./DeleteConfigTagsModal";

export const TogglePnlTemplateTag = ({ itemTplTag }) => {
  const [toggleOpen, setToggleOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [associatedPrinters, setAssociatedPrinters] = useState([]);
  const [printers, setPrinters] = useState([]);
  const [devicePrinters, setDevicePrinters] = useState([]);
  const { beforeSubmit, afterSubmit } = useRequest();

  const history = useHistory();
  const [deleteErrorModal, setdeleteErrorModal] = useState(false);
  const [deleteErrorMsg, setdeleteErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  // Sincroniza associatedPrinters con itemTplTag.devices
  useEffect(() => {
    if (itemTplTag.devices) {
      setAssociatedPrinters(itemTplTag.devices);
    }
  }, [itemTplTag.devices]);

  useEffect(() => {
    DeviceService.devices({ device_type: "PRINTER" }).then(data => {
      setDevicePrinters(data);
      data = data.map(device => {
        return { label: device.name, option: device.id };
      });
      setPrinters(data);
    });
  }, []);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const deleteConfigTagConfirm = () => {
    setDeleteModalOpen(true);
  };

  const deleteConfigTag = () => {
    setLoading(true);
    TagService.deleteConfigTag(itemTplTag.id)
      .then(rta => {
        history.push(`/admin/config_tags`);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        setdeleteErrorModal(true);
        setdeleteErrorMsg(i18n.t("cant.delete.configtag"));
      });
  };

  const handleSaveDevices = selectedDevices => {
    // Construir el array de dispositivos asociados con el formato esperado
    const newAssociatedPrinters = selectedDevices.map(deviceId => ({
      device: devicePrinters.find(printer => printer.id === deviceId)?.id
    }));
    itemTplTag.devices = newAssociatedPrinters;
    beforeSubmit();
    TagService.updateConfigTag(itemTplTag.id, itemTplTag)
      .then(configTag => {
        // console.log("----configTag actualizada: ", configTag);
      })
      .catch(error => {
        EventRepository.notificationSend({
          label: i18n.t("generic.error"),
          type: "error"
        });
      })
      .finally(() => {
        afterSubmit();
      });

    setAssociatedPrinters(newAssociatedPrinters);
    setModalOpen(false);
  };

  return (
    <div className={styles["toggle-pnl-template-tag-container"]}>
      <div
        className={styles["toggle-pnl-template-tag-title"]}
        onClick={() => setToggleOpen(!toggleOpen)}
      >
        <h4>{itemTplTag.name}</h4>
        {isMobile && (
          <i
            name="icon-chevron"
            className={`icon-chevron ${styles["toggle-pnl-template-tag-chevron"]} ${toggleOpen ? styles["open"] : ""}`}
          ></i>
        )}

        <div className={styles["button-group"]}>
          <button
            className={styles["edit-btn"]}
            onClick={() =>
              history.push(`/admin/config_tags/edit/${itemTplTag.id}`)
            }
            title={i18n.t("edit.configtag")}
          >
            <i className={"icon-iconos_editar"}></i>
          </button>

          <button
            className={styles["delete-btn"]}
            onClick={deleteConfigTagConfirm}
            title={i18n.t("delete.configtag")}
          >
            <i className={"icon-iconos_eliminar"}></i>
          </button>
        </div>
      </div>

      {(!isMobile || toggleOpen) && (
        <div>
          <div
            className={styles["toggle-pnl-template-tag-section"]}
            key={itemTplTag.name}
          >
            <div className={styles["toggle-pnl-template-tag-section-desc-column"]}>
              <div className={styles["toggle-pnl-template-tag-section-type-pill"]}>
                {capitalize(i18n.t(itemTplTag.type?.toLowerCase()))}
              </div>
              <div className={styles["toggle-pnl-template-tag-section-description"]}>
                {itemTplTag.description}
              </div>
            </div>

            <div className={styles["toggle-pnl-template-tag-section-dimensions-column"]}>
              <div className={styles["title-container"]}>
                <span className={styles["icon-boxes-container"]}>
                  <img src={RulerIcon} alt="ruler icon" className={styles["ruler-icon"]} />
                </span>
                <h4>{i18n.t("measures").toUpperCase()}</h4>
              </div>
              <div className={styles["row"]}>
                <div className={styles["info-block"]}>
                  <div className={styles["label"]}>{i18n.t("height")}</div>
                  <div className={styles["value"]}>{itemTplTag.height} mm</div>
                </div>
                <div className={styles["info-block"]}>
                  <div className={styles["label"]}>{i18n.t("width")}</div>
                  <div className={styles["value"]}>{itemTplTag.width} mm</div>
                </div>
              </div>
            </div>

            <div className={styles["toggle-pnl-template-tag-section-memories-column"]}>
              <div className={styles["title-container"]}>
                <span className={styles["icon-boxes-container"]}>
                  <img src={MemoryIcon} alt="memory icon" className={styles["memory-icon"]} />
                </span>
                <h4>{i18n.t("memories").toUpperCase()}</h4>
              </div>
              <div className={styles["row"]}>
                <div className={styles["info-block"]}>
                  <div className={styles["label"]}>{i18n.t("epc.memory")}</div>
                  <div className={styles["value"]}>{itemTplTag.mem_epc} GB</div>
                </div>
                <div className={styles["info-block"]}>
                  <div className={styles["label"]}>{i18n.t("user.memory")}</div>
                  <div className={styles["value"]}>{itemTplTag.mem_user} GB</div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles["printer-association-container"]}>
            <div className={styles["printer-association-title-first-column"]}>
              <div className={styles["printer-association-title"]}>
                <div className={styles["icon-container"]}>
                  <img src={PrinterIcon} alt="printer icon" className={styles["printer-icon"]} />
                </div>
                <div className={styles["title"]}>
                  <div className={styles["first_div"]}>{i18n.t("associated.printers")} </div>
                  <div className={styles["printer-association-list"]}>
                    {associatedPrinters.map(device => {
                      const printer = printers.find(
                        printer => printer.option === device.device
                      );
                      return (
                        <span key={device.device}>
                          {printer?.label}
                          {associatedPrinters.indexOf(device) <
                            associatedPrinters.length - 1 && ", "}
                        </span>
                      );
                    })}
                    {associatedPrinters.length === 0 && (i18n.t("no_defined"))}
                  </div>

                </div>


              </div>

            </div>
            <div>
              <button
                className={styles["printer-association-button-container"]}
                onClick={handleOpenModal}
              >
                <button type="button" className={styles["printer-button"]}>
                  <i className="icon icon-iconos_mas"></i>
                  {i18n.t("associate.printer").toUpperCase()}
                </button>
              </button>
            </div>
          </div>
        </div>
      )}

      {deleteModalOpen && (
        <DeleteConfigTagsModal
          open={deleteModalOpen}
          handleClose={() => setDeleteModalOpen(false)}
          handleCancel={() => setDeleteModalOpen(false)}
          handleConfirm={() => {
            deleteConfigTag();
            setDeleteModalOpen(false);
          }}
        />
      )}

      {modalOpen && (
        <PrinterModal
          printers={printers}
          devicePrinters={devicePrinters}
          associatedPrinters={associatedPrinters}
          onClose={handleCloseModal}
          onSave={handleSaveDevices}
        />
      )}

      {deleteErrorModal && (
        <GenericErrorModal
          open={deleteErrorModal}
          handleClose={() => setdeleteErrorModal(false)}
          error={deleteErrorMsg}
        ></GenericErrorModal>
      )}

      {loading && <Loader />}
    </div>
  );
};

export default TogglePnlTemplateTag;
